<template>
  <b-row
    :class="{
      'no-items': !userHasTickets(user) && !userHasTasks(user)
    }"
  >
    <b-col md="6" class="align-left">
      <template v-if="userHasTasks(user)">
        <b-icon-list-task> </b-icon-list-task> :
        <b v-if="getIncompleteTaskCount(user.tasks)">{{
          getIncompleteTaskCount(user.tasks)
        }}</b>
      </template>
    </b-col>
    <b-col md="6" class="align-right">
      <template v-if="userHasTickets(user)">
        <font-awesome-icon class="ticket" icon="ticket-alt" />
        :
        <b>{{ user.tickets.length }}</b>
      </template>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "TicketTaskCount",
  props: {
    user: {
      required: true,
      type: Object
    }
  },
  data() {
    return {}
  },
  computed: {},
  created() {},
  methods: {
    /**
     * Gets incomplete task count
     * @param tasks
     * @returns {*}
     */
    getIncompleteTaskCount(tasks) {
      return tasks.filter(x => !x.completed)?.length ?? 0
    },

    /**
     * Checks if user has tasks
     * @param user
     * @returns {number}
     */
    userHasTasks(user) {
      return user?.tasks?.length
    },
    /**
     * Checks if user has tickets
     * @param user
     * @returns {*}
     */
    userHasTickets(user) {
      return user?.tickets?.length
    }
  }
}
</script>

<style scoped>
.align-left {
  text-align: left;
}

.align-right {
  text-align: right;
}
.no-items {
  margin: 1.1rem;
}
.ticket {
  color: darkmagenta;
}
</style>
